import List from './List';
import CN51 from './CN51';
import CN66 from './CN66';

const Components = {
    List : List,
    CN51 : CN51,
    CN66 : CN66
}

export default Components;